import {
  PopoverPanel as HeadlessPopoverPanel,
  PopoverPanelProps as HeadlessPopoverPanelProps,
} from "@headlessui/react"
import { RefObject } from "react"

import { classNames } from "../../../../lib/classNames"

interface PopoverPanelProps extends HeadlessPopoverPanelProps {
  className?: string
  ref?: RefObject<HTMLDivElement | null>
}

const PopoverPanel = ({ ref, className, ...otherProps }: PopoverPanelProps) => {
  return (
    <HeadlessPopoverPanel
      anchor={{ to: "bottom start", gap: 4, padding: 4 }}
      className={classNames(
        "w-80",
        "bg-elevation-surface-default",
        "border-v2-border-default rounded-overlay border",
        "shadow-surface",
        "overflow-hidden",
        "z-50",
        className
      )}
      focus
      {...otherProps}
      ref={ref}
    />
  )
}

PopoverPanel.displayName = "PopoverPanel"

export default PopoverPanel
